import { Button, Group, Modal, Stack, Text, ThemeIcon } from '@mantine/core';
import { Icon } from '@common/components/foundations/icons';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '@common/mantine/components/modal-footer';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  children?: React.ReactNode;
  user?: string;
};

export const DeleteAdminUserModal = ({ onDelete, user, isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      size="sm"
      title={
        <Group gap="xs">
          <ThemeIcon color="red" radius="xl">
            <Icon.Delete color="white" className="h-4 w-4" />
          </ThemeIcon>
          {t('Delete User: ')} {user}
        </Group>
      }
      styles={{ body: { padding: 0 } }}
    >
      <Stack p="md">
        <Text>
          {t('Are you sure you want to delete')} {user}
        </Text>
      </Stack>
      <ModalFooter>
        <Button variant="subtle" onClick={onClose}>
          Cancel
        </Button>
        <Button color="red.7" onClick={onDelete}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
